module.exports = __webpack_public_path__ + "img/user-deleted.9275028.webp";